module.exports = __webpack_public_path__ + "img/KK0043C-BL.fc414eef.jpg";